import BaseValidator from 'services/validations/base-validator';
import {getUserSettingsValidator} from 'services/sports/factory';
import {getEditedLineupValidator} from '../sports/factory';

function assertUserConfigurationIsValid(params) {
    const {sportConfig} = params;
    const validator = getUserSettingsValidator(sportConfig).exec('getInterface', null, new BaseValidator());

    if (!validator.validate()) {
        throw Error(validator.getFirstError());
    }
}

function assertEditedLineupIsValid(params) {
    const {sportConfig} = params;
    const validator = getEditedLineupValidator(sportConfig).exec('getInterface', params, new BaseValidator());

    if (!validator.validate()) {
        throw Error(validator.getFirstError());
    }
}

export {assertUserConfigurationIsValid, assertEditedLineupIsValid};
